import { IState } from '../IState';

const authStoreSelector = (state: IState) => state.auth;

const authStoreUserSelector = (state: IState) => authStoreSelector(state).user;
const authStoreUserDataSelector = (state: IState) => authStoreUserSelector(state).data;
const authStoreUserMetaSelector = (state: IState) => authStoreUserSelector(state).meta;

export const authUserSelector = (state: IState) => authStoreUserDataSelector(state).user;
export const authIsAuthorizedSelector = (state: IState) => Boolean(authStoreUserDataSelector(state).user);
export const authNetworkStatusSelector = (state: IState) => authStoreUserMetaSelector(state).networkStatus;
